import { CSSProperties, FC, HTMLProps } from 'react'

import { cn } from 'src/lib/cn'

export interface SeparatorProps extends HTMLProps<HTMLDivElement> {
  withoutMargin?: boolean
  offsetHorizontal?: number
  marginTop?: number
  marginBottom?: number
  height?: number
}

const Separator: FC<SeparatorProps> = ({
  className,
  withoutMargin,
  style,
  offsetHorizontal,
  marginBottom,
  marginTop,
  height,
  ...divProps
}) => {
  const offset: CSSProperties = offsetHorizontal
    ? {
        marginLeft: offsetHorizontal,
        marginRight: offsetHorizontal,
        width: `calc(100% - ${offsetHorizontal * 2}px)`,
      }
    : {}

  return (
    <div
      className={cn('bg-light-grey my-4.5 h-px w-full', withoutMargin && 'my-0', className)}
      data-testid="separator"
      style={{
        marginTop,
        marginBottom,
        height,
        ...style,
        ...offset,
      }}
      {...divProps}
    />
  )
}

export default Separator
